import { render, staticRenderFns } from "./formComponent.vue?vue&type=template&id=5e7143d5&scoped=true"
import script from "./formComponent.vue?vue&type=script&lang=js"
export * from "./formComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7143d5",
  null
  
)

export default component.exports